import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import moment from "moment";
import Form from "../../components/common/form";
import { getAccount, getAccountNav, saveAccount } from "../../services/accountService";
import { getCustomers } from "../../services/customerService";
import { getCustomer } from "../../services/customerService";
import { getServices } from "../../services/servicesService";
import { getService } from "../../services/servicesService";
import { getEmployees } from "../../services/employeeService";
import RecordNavigation from "../../components/common/recordNavigation";
import Account360Panel from "./account360/Account360Panel";

class AccountForm extends Form {
  state = {
    title: "View Account",
    loadingRecord: true,
    viewMode: "workspace",
    data: {
      username: "",
      password: "",
      groupid: "1",
      enableuser: "",
      name: "",
      customerid: "",
      company: "",
      phone: "",
      mobile: "",
      address: "",
      city: "",
      country: "",
      state: "",
      comment: "",
      gpslat: "0.0",
      gpslong: "0.0",
      mac: "00:00:00:00:00:00",
      expiration: "",
      srvid: "",
      staticip: "0.0.0.0",
      ippool: "default",
      createdby: "",
      email: "",
      custattr: "",
      alertemail: "",
      alertsms: "",
    },
    boolean: [
      { id: 1, label: "Active", value: true },
      { id: 2, label: "Inactive", value: false }
    ],
    countryList: [
      { id: 1, label: "Nigeria", value: "Nigeria" }
    ],
    stateList: [
      { id: 1,  label: "Abia", value: "AB"},
      { id: 2,  label: "Adamawa", value: "AD"},
      { id: 3,  label: "Akwa Ibom", value: "AK"},
      { id: 4,  label: "Anambra", value: "AN"},
      { id: 5,  label: "Bauchi", value: "BA"},
      { id: 6,  label: "Bayelsa", value: "BY"},
      { id: 7,  label: "Benue", value: "BE"},
      { id: 8,  label: "Borno", value: "BO"},
      { id: 9,  label: "Cross River", value: "CR"},
      { id: 10,  label: "Delta", value: "DE"},
      { id: 11,  label: "Ebonyi", value: "EB"},
      { id: 12,  label: "Edo", value: "ED"},
      { id: 13,  label: "Ekiti", value: "EK"},
      { id: 14,  label: "Enugu", value: "EN"},
      { id: 15,  label: "Federal Capital Territory", value: "FC"},
      { id: 16,  label: "Gombe", value: "GO"},
      { id: 17,  label: "Imo", value: "IM"},
      { id: 18,  label: "Jigawa", value: "JI"},
      { id: 19,  label: "Kaduna", value: "KD"},
      { id: 20,  label: "Kano", value: "KN"},
      { id: 21,  label: "Katsina", value: "KT"},
      { id: 22,  label: "Kebbi", value: "KE"},
      { id: 23,  label: "Kogi", value: "KO"},
      { id: 24,  label: "Kwara", value: "KW"},
      { id: 25,  label: "Lagos", value: "LA"},
      { id: 26,  label: "Nasarawa", value: "NA"},
      { id: 27,  label: "Niger", value: "NI"},
      { id: 28,  label: "Ogun", value: "OG"},
      { id: 29,  label: "Ondo", value: "ON"},
      { id: 30,  label: "Osun", value: "OS"},
      { id: 31,  label: "Oyo", value: "OY"},
      { id: 32,  label: "Plateau", value: "PL"},
      { id: 33,  label: "Rivers", value: "RI"},
      { id: 34,  label: "Sokoto", value: "SO"},
      { id: 35,  label: "Taraba", value: "TA"},
      { id: 36,  label: "Yobe", value: "YO"},
      { id: 37,  label: "Zamfara", value: "ZA"},
    ],
    customerList: [],
    serviceList: [],
    employeeList: [],
    errors: {},
    advanced: false,
    navPaths: [],
    filters: null,
  };

  searchCustomers = async (term) => {
    try {
      const response = await getCustomers({ page: 1, pageSize: 20, search: term, sortBy: 'id', sortOrder: 'DESC' });
      const payload = response?.data;
      const customers = Array.isArray(payload) ? payload : (payload?.data || []);

      const customerList = customers.map(customer => ({
        id: customer.id,
        label: customer.company || customer.name || customer.fullname || String(customer.id),
        value: customer.id,
      }));

      this.setState({ customerList });
    } catch (error) {
      console.error('Error searching customers:', error);
      this.setState({ customerList: [] });
    }
  };

  searchServices = async (term) => {
    try {
      const response = await getServices({ page: 1, pageSize: 50, search: term, sortBy: 'name', sortOrder: 'ASC' });
      const payload = response?.data;
      const services = Array.isArray(payload) ? payload : (payload?.data || []);

      const serviceList = services.map(service => ({
        id: service.id,
        label: service.name,
        value: service.id,
      }));

      this.setState({ serviceList });
    } catch (error) {
      console.error('Error searching services:', error);
      this.setState({ serviceList: [] });
    }
  };

  async populateNavigationPaths() {
    try {
      const filters = this.props.location?.state?.filters;
      if (!filters) {
        const navPaths = this.props.location?.state?.nav?.paths || [];
        this.setState({ navPaths });
        return;
      }

      const params = {
        page: 1,
        pageSize: 1000,
        sortBy: filters.sortColumn?.path || 'id',
        sortOrder: filters.sortColumn?.order || 'desc',
      };
      if (filters.searchQuery) params.search = filters.searchQuery;

      const response = await getAccountNav(params);
      const accounts = response?.data?.data || [];
      const navPaths = accounts.map(a => `/accounts/${a.username}`);
      this.setState({ navPaths, filters });
    } catch (error) {
      console.error('Error fetching account navigation paths:', error);
      const navPaths = this.props.location?.state?.nav?.paths || [];
      this.setState({ navPaths });
    }
  }

  schema = {
    id: Joi.any(),
    username: Joi.string().max(64).required(),
    password: Joi.string().max(32).required(),
    groupid: Joi.number().integer().required(),
    enableuser: Joi.boolean().required(),
    name: Joi.string().max(50).required(),
    customerid: Joi.number().integer().required(),
    company: Joi.any(),
    phone: Joi.string().max(15).required(),
    mobile: Joi.any(),
    address: Joi.string().max(255).required(),
    city: Joi.string().max(50).required(),
    country: Joi.string().max(50).required(),
    state: Joi.string().max(50).required(),
    comment: Joi.any(),
    gpslat: Joi.number().precision(14),
    gpslong: Joi.number().precision(14),
    mac: Joi.string().length(17),
    expiration: Joi.date().allow(null),
    srvid: Joi.number().integer().required(),
    staticip: Joi.string().max(15),
    ippool: Joi.string().max(36).required(),
    createdby: Joi.number().integer().required(),
    email: Joi.string().max(100).required(),
    custattr: Joi.any(),
    alertemail: Joi.boolean(),
    alertsms: Joi.boolean(),
  };

  async populateUser() {
    try {
      this.setState({ loadingRecord: true });

      const accountId = this.props.match.params.id;
      if (accountId === "new") {
        const title = "New Account";
        this.setState({ title: title, loadingRecord: false });
        return;
      }

      const { data: account } = await getAccount(accountId);
      const data = this.mapToViewModel(account);

      const customerList = [];
      if (data.customerid) {
        try {
          const { data: customer } = await getCustomer(data.customerid);
          const label = customer.company || customer.fullname || String(data.customerid);
          customerList.push({ id: data.customerid, label, value: data.customerid });
        } catch (e) {
          customerList.push({ id: data.customerid, label: String(data.customerid), value: data.customerid });
        }
      }

      const serviceList = [];
      const nested = account.Service || account.service;
      if (data.srvid) {
        try {
          const { data: service } = await getService(data.srvid);
          const label = service?.name || nested?.name || String(data.srvid);
          serviceList.push({
            id: data.srvid,
            label,
            value: data.srvid,
            billing_mode: service?.billing_mode ?? nested?.billing_mode,
            is_catalogue: service?.is_catalogue ?? nested?.is_catalogue,
            contract_no: service?.contract_no ?? nested?.contract_no,
            contract_status: service?.contract_status ?? nested?.contract_status,
          });
        } catch (e) {
          serviceList.push({
            id: data.srvid,
            label: nested?.name || String(data.srvid),
            value: data.srvid,
            billing_mode: nested?.billing_mode,
            is_catalogue: nested?.is_catalogue,
            contract_no: nested?.contract_no,
            contract_status: nested?.contract_status,
          });
        }
      }

      this.setState({ data, customerList, serviceList, loadingRecord: false });
    } catch (ex) {
      this.setState({ loadingRecord: false });
      if (ex.response && ex.response.status === 404)
        this.props.history.replace("/not-found");
    }
  }

  async populateServiceList () {
    return;
  };

  async populateEmployeeList() {
    const { data: employees } = await getEmployees();

    const employeeList = employees.map(employee => {
      const employeelist = {};
      employeelist['id'] = employee.id;
      employeelist['label'] = employee.name;
      employeelist['value'] = employee.id;
      return employeelist;
    })
    this.setState({ employeeList });
  }

  populateCreatedBy () {
    if (!this.state.data.id) {
      let data = {...this.state.data};
      data['createdby'] = this.props.user.id;
      this.setState({ data });     
    }
  }

  populateExpiration () {
    const date = new Date();
    const formatted = moment(date).format("YYYY-MM-DDThh:mm").toString(); // 2024-01-02T10:48

    let data = {...this.state.data};
    data['expiration'] = formatted;
    this.setState({ data });    
  }

  async componentDidMount() {
    await this.populateExpiration ();
    await this.populateUser()
    .then(
      this.populateCreatedBy()
    );

    await this.populateNavigationPaths();
  }

  async componentDidUpdate(prevProps) {
    const prevPath = prevProps.location?.pathname;
    const nextPath = this.props.location?.pathname;

    if (prevPath !== nextPath) {
      this.setState({ loadingRecord: true });
      await this.populateUser();
      await this.populateNavigationPaths();
    }
  }

  mapToViewModel(account) {
    return {
      id: account.id,
      username: account.username,
      password: account.password,
      groupid: account.groupid,
      enableuser: account.enableuser,
      name: account.name,
      customerid: account.customerid,
      company: account.company,
      phone: account.phone,
      mobile: account.mobile,
      address: account.address,
      city: account.city,
      country: account.country,
      state: account.state,
      comment: account.comment,
      gpslat: account.gpslat,
      gpslong: account.gpslong,
      mac: account.mac,
      expiration: account.expiration,
      srvid: account.srvid,
      staticip: account.staticip,
      ippool: account.ippool,
      createdby: account.createdby,
      email: account.email,
      custattr: account.custattr,
      alertemail: account.alertemail,
      alertsms: account.alertsms,
      billing_mode: account.billing_mode ?? null,
      auto_renew_enabled: !!account.auto_renew_enabled,
      effective_billing_mode: account.effective_billing_mode ?? null,
      // Keep nested Service for Account 360 billing-mode / CS detection (E28 / ADR-0014)
      Service: account.Service || account.service || null,
    };
  }

  doSubmit = async () => {
    try {
      if (!this.state.data.id) {
        let data = {...this.state.data};
        delete data.createdby;
        data = [...data, {createdby: this.props.user.id}]
        this.setState({ data });
      }

      await saveAccount(this.state.data);
      this.props.history.push("/accounts");
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        toast.error("Error: " + ex.response.data);
      }
    }
  };

  render() {
    const showWorkspace =
      !!this.state.data.id &&
      this.state.viewMode === "workspace" &&
      !this.state.loadingRecord;

    if (showWorkspace) {
      return (
        <Account360Panel
          account={this.state.data}
          serviceList={this.state.serviceList}
          history={this.props.history}
          location={this.props.location}
          navPaths={this.state.navPaths}
        />
      );
    }

    let advanced = false;
    return (
      <React.Fragment>
        <form className="" onSubmit={this.handleSubmit}>
          {this.renderFormButtonBar(false)}

          <div className="form-input">
            <div className="d-flex justify-content-between align-items-center pt-2 pb-3">
              <h4 className="text-secondary m-0">
                {this.state.loadingRecord ? (
                  <>
                    <i className="animate-spin fa fa-spinner" /> Loading Account
                  </>
                ) : (
                  this.state.title
                )}
              </h4>
              <RecordNavigation
                history={this.props.history}
                currentPath={this.props.location.pathname}
                paths={this.state.navPaths || []}
              />
            </div>
            {!this.state.loadingRecord && (
              <>
                {this.renderInput("username", "Account ID", "text", this.state.data.id, "", true)}
                {this.renderSelect("enableuser", "Status", this.state.boolean, true)}
                {this.renderSearchableSelect("srvid", "Service", this.state.serviceList, !!this.state.data.id, { onSearch: this.searchServices })}
                {this.renderSearchableSelect("customerid", "Customer", this.state.customerList, !!this.state.data.id, { onSearch: this.searchCustomers })}
                {this.renderInput("expiration", "Expiration", "datetime-local", true )}

                <hr />
                <div>
                  {this.renderInput("name", "Name", "", true)}
                  {this.renderInput("company", "Company", "", true)}
                  {this.renderInput("phone", "Phone", "", true)}
                  {this.renderInput("mobile", "Mobile", "", true)}
                  {this.renderInput("email", "Email", "", true)}
                  {this.renderInput("address", "Address", "", true)}
                  {this.renderInput("city", "City", "", true)}
                  {this.renderSelect("state", "State", this.state.stateList, true)}
                  {this.renderSelect("country", "Country", this.state.countryList, true)}
                </div>
              </>
            )}
          </div>
        </form>
      </React.Fragment>
    );
  }
}

export default AccountForm;
